import { createSlice } from '@reduxjs/toolkit';
import { IGetSelectedConfigDetailsInitialState } from 'redux/types/GetSelectedConfigDetails.type';

import { APIStatus } from '../../../services/api/apiStatusCode';

export const getSelectedConfigInitialState: IGetSelectedConfigDetailsInitialState =
  {
    status: APIStatus.INIT,
    data: {},
    isLoading: false,
    error: {},
  };

const GetSelectedConfigDetailsSlice = createSlice({
  name: 'getSelectedConfigDetails',
  initialState: getSelectedConfigInitialState,
  reducers: {
    setSelectedConfigDetails: (state, action) => {
      state.data = action.payload;
      state.status = APIStatus.SUCCESS;
    },
    resetGetSelectedConfigDetailsState: () => {
      return getSelectedConfigInitialState;
    },
  },
});

export const { setSelectedConfigDetails, resetGetSelectedConfigDetailsState } =
  GetSelectedConfigDetailsSlice.actions;

export default GetSelectedConfigDetailsSlice.reducer;
